import { createFileRoute } from '@tanstack/react-router';
import CreateCompanyDepartments from '@/modules/settings/pages/CreateCompanyDepartments';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/settings/company-departments/new',
)({
  component: CreateCompanyDepartments,
});
